import { render, staticRenderFns } from "./IconSvgPptx.vue?vue&type=template&id=cff92570&scoped=true&"
import script from "./IconSvgPptx.vue?vue&type=script&lang=js&"
export * from "./IconSvgPptx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff92570",
  null
  
)

export default component.exports